/* eslint-disable no-case-declarations */
import { DOMParse, parseCSS } from "../dom";

// 合并 DOMParseListeners
interface DOMParseListeners {
  result(items: Record<string, string>[]): void;
}

export class SVGParse extends DOMParse {
  currentItem: Record<string, string> = {};
  items: Record<string, string>[] = [];

  groups: Record<string, string>[] = [];

  globalStyles: Record<string, string[]> = {};

  grad: Record<string, any> = {};
  idtops: Record<string, string> = {};
  text = "";

  constructor(sourceString: string) {
    super(sourceString);

    this.on("tag", (tagname: string, attrs: Record<string, string>) => {
      this.text = "";
      this.currentItem = { type: tagname };
      switch (tagname) {
        case "g":
          this.groups.push(this.currentItem);
          break;
      }
      this.processAttrs(tagname, attrs);
    });

    this.on("text", (text: string) => {
      if (this.currentItem.type == "style") {
        try {
          const parsedCSS = parseCSS(text);
          for (const rule of parsedCSS.stylesheet.rules) {
            for (const declaration of rule.declarations) {
              for (const selector of rule.selectors) {
                this.globalStyles[selector] = this.globalStyles[selector] || [];
                this.globalStyles[selector].push(
                  `${declaration.property}:${declaration.value}`
                );
              }
            }
          }
          // console.log(this.globalStyles);
        } catch (e) {
          console.error("CAN'T parse css text: " + text);
        }
        return;
      }
      this.text += text;
    });

    this.on("/tag", (tagname: string, attrs: Record<string, string>) => {
      /// *.attrend
      let i = this.groups.length;
      while (i--) {
        if (this.groups[i] != this.currentItem) {
          let groupTransform = "";
          let groupStyle = "";
          for (const key in this.groups[i]) {
            if (key == "transform") {
              groupTransform = this.groups[i].transform as string;
            } else if (
              key == "class" &&
              this.globalStyles["." + this.groups[i][key]]
            ) {
              groupStyle =
                this.globalStyles["." + this.groups[i][key]].join(";") +
                ";" +
                groupStyle;
            } else if (
              key == "id" &&
              this.globalStyles["#" + this.groups[i][key]]
            ) {
              groupStyle =
                this.globalStyles["#" + this.groups[i][key]].join(";") +
                ";" +
                groupStyle;
            } else if (typeof this.currentItem[key] === "undefined") {
              // 除 transform 和 style , 使用group属性
              this.currentItem[key] = this.groups[i][key];
            }
          }
          if (typeof this.currentItem.transform === "undefined") {
            this.currentItem.transform = groupTransform;
          } else {
            this.currentItem.transform += " " + groupTransform;
          }
          /// add group style
          if (typeof this.currentItem.style === "undefined") {
            this.currentItem.style = groupStyle;
          } else {
            this.currentItem.style = groupStyle + this.currentItem.style;
          }
          /// add self global style
          if (
            this.currentItem.class &&
            this.globalStyles["." + this.currentItem.class]
          ) {
            this.currentItem.style =
              this.globalStyles["." + this.currentItem.class].join(";") +
              ";" +
              this.currentItem.style;
          } else if (
            this.currentItem.id &&
            this.globalStyles["#" + this.currentItem.id]
          ) {
            this.currentItem.style =
              this.globalStyles["#" + this.currentItem.id].join(";") +
              ";" +
              this.currentItem.style;
          }
          applyStyle(
            this.currentItem.style,
            this.currentItem,
            SVGAttributeRange
          );
        }
      }

      this.processAttrs(tagname, attrs);

      switch (tagname) {
        case "g":
          this.groups.pop();
          break;
        case "cirlce":
          this.addToItems();
          break;
        case "ellipse":
          this.addToItems();
          break;
        case "polygon":
          this.addToItems();
          break;
        case "path":
          this.addToItems();
          break;
        case "line":
          this.addToItems();
          break;
        case "rect":
          this.addToItems();
          break;
        case "image":
          this.addToItems();
          break;
        case "text":
          this.currentItem.text = this.text;
          this.currentItem["text-anchor"] =
            this.currentItem["text-anchor"] || "start";
          this.addToItems();
          break;
      }
    });

    this.on("finish", () => {
      this.emit("result", this.items);
    });
  }

  parse() {
    super.parse();
    return this.items;
  }

  processAttrs(tagname: string, attrs: Record<string, string>) {
    let s: any[] = [];
    let stop: any;

    switch (tagname) {
      case "svg":
        let width = "";
        let height = "";
        if (attrs.width && attrs.height) {
          width = attrs.width;
          height = attrs.height;
        } else if (attrs.viewBox) {
          const viewBoxs = attrs.viewBox.split(/\s+/gi);
          if (viewBoxs.length == 4) {
            width = String(parseFloat(viewBoxs[2]) - parseFloat(viewBoxs[0]));
            height = String(parseFloat(viewBoxs[3]) - parseFloat(viewBoxs[1]));
          }
        }
        if (width && height) {
          this.items.push({
            type: "viewbox",
            width,
            height
          });
        }
        break;
      case "line":
        if (
          typeof attrs.x1 == "number" &&
          typeof attrs.y1 == "number" &&
          typeof attrs.x2 == "number" &&
          typeof attrs.y2 == "number"
        ) {
          this.currentItem.path =
            "M" + [attrs.x1, attrs.y1, attrs.x2, attrs.y2];
        }
        break;
      case "stop":
        stop = {};
        if (attrs.style) {
          applyStyle(attrs.style, stop);
        }
        stop.offset = stop.offset || attrs.offset;
        stop.color = stop["stop-color"] || attrs["stop-color"];
        stop.opacity = stop["stop-opacity"] || attrs["stop-opacity"];
        if (~(stop.offset + "").indexOf("%")) {
          stop.offset = parseFloat(stop.offset);
        } else {
          stop.offset = parseFloat(stop.offset) * 100;
        }
        stop.offset = +stop.offset.toFixed(2);
        this.grad.stops.push(stop);
        break;
      case "linearGradient":
        this.grad.angle = (
          360 +
          angle(
            parseFloat(attrs.x1),
            parseFloat(attrs.y1),
            parseFloat(attrs.x2),
            parseFloat(attrs.y2),
            parseFloat(attrs.x1) + 100,
            parseFloat(attrs.y1)
          )
        ).toFixed(2);
        s = [this.grad.angle];
        for (let i = 0, ii = this.grad.stops.length; i < ii; i++) {
          stop = this.grad.stops[i];
          if (i && i != ii - 1) {
            s.push(stop.color + ":" + stop.offset);
          } else {
            s.push(stop.color);
          }
        }
        this.idtops[this.grad.id] = s.join("-");
        this.items.forEach((item) => {
          if (item.fillid == this.grad.id) {
            item.fill = this.idtops[this.grad.id];
          }
        });
        break;
      case "radialGradient":
        s = [];
        for (let i = 0, ii = this.grad.stops.length; i < ii; i++) {
          stop = this.grad.stops[i];
          if (i && i != ii - 1) {
            s.push(stop.color + ":" + stop.offset);
          } else {
            s.push(stop.color);
          }
        }
        this.idtops[this.grad.id] = s.join("-");
        this.items.forEach((item) => {
          if (item.fillid == this.grad.id) {
            item.fill = this.idtops[this.grad.id];
          }
        });
        break;
    }

    for (const key in attrs) {
      const value = attrs[key];
      /// 复制attribute
      if (SVGAttributeRange.includes(key)) {
        this.currentItem[key] = value;
      }
      if (key === "id") {
        if (this.currentItem.type === "linearGradient") {
          this.grad = {
            id: key,
            stops: []
          };
        }
        if (this.currentItem.type === "radialGradient") {
          this.grad = {
            id: key,
            stops: []
          };
        }
      }
      if (key === "style") {
        /// 设置 svg element 样式
        applyStyle(value, this.currentItem, SVGAttributeRange);
      }
      if (key === "transform") {
        this.currentItem.transform =
          value + (this.currentItem.transform || " ");
      }
      if (key === "fill") {
        const result = value.match(/url\(#([^)]+)\)/);
        if (result) {
          const id = result[1];
          this.currentItem.fillid = id;
          if (this.idtops[id]) {
            this.currentItem.fill = this.idtops[id];
          }
        }
      }
      if (key === "points") {
        if (this.currentItem.type == "polygon") {
          this.currentItem.path = "M" + value + "z";
        }
      }
      if (key === "d") {
        if (this.currentItem.type == "path") {
          this.currentItem.path = value;
        }
      }
      if (key === "xlink:href") {
        if (this.currentItem.type == "image") {
          this.currentItem.src = value;
        }
      }
    }
  }

  addToItems() {
    this.items.push(this.currentItem);
  }
}

export default SVGParse;

function angle(
  x1: number,
  y1: number,
  x2: number,
  y2: number,
  x3?: number,
  y3?: number
): number {
  if (typeof x3 == "undefined" || typeof y3 == "undefined") {
    const x = x1 - x2;
    const y = y1 - y2;
    if (!x && !y) {
      return 0;
    }
    return (180 + (Math.atan2(-y, -x) * 180) / Math.PI + 360) % 360;
  } else {
    return angle(x1, y1, x3, y3) - angle(x2, y2, x3, y3);
  }
}

function applyStyle(
  css: string,
  el: { [index: string]: any },
  SVGAttributeRange?: string[]
) {
  const rules = (css + "").split(";");
  const trim = /^\s+|\s+$/g;
  for (let i = 0, ii = rules.length; i < ii; i++) {
    const pair = rules[i].split(":");
    const key = pair[0].replace(trim, "").replace(/[A-Z]/g, function (letter) {
      return "-" + letter.toLowerCase();
    });
    if (!SVGAttributeRange || SVGAttributeRange.includes(key)) {
      el[key] = pair[1].replace(trim, "");
    }
  }
}

const SVGAttributeRange: string[] = [
  "id",
  "class",
  "viewBox",
  "width",
  "height",
  "x",
  "y",
  "cx",
  "cy",
  "r",
  "rx",
  "ry",

  "cursor",
  "opacity",
  "src",

  "fill",
  "fill-opacity",

  "stroke",
  "stroke-dasharray",
  "stroke-linecap",
  "stroke-linejoin",
  "stroke-miterlimit",
  "stroke-opacity",
  "stroke-width",

  "text-anchor",

  "font",
  "font-family",
  "font-size",
  "font-style",
  "font-weight",
  "letter-spacing"
];
